import { arrayToObject } from 'lib/array/arrayUtils'
import { createSelector } from 'reselect'

const getUsersPartnershipForGeo = createSelector(
  (state: App.State) => state.geo.partnership,
  (state: App.State) => state.auth.account.partnerships,
  (partnership, accountPartnerships) => {
    if (partnership) {
      return (accountPartnerships?.[partnership.prefix])
    }
  },
)

export const getPartnershipFields = createSelector(
  (state: App.State) => getUsersPartnershipForGeo(state),
  (state: App.State) => state.geo.partnership?.userFields,
  (accountPartnerships, partnershipAccountFields) => {
    if (accountPartnerships) {
      return arrayToObject<App.UserField, any>(partnershipAccountFields,
        field => field.name,
        field => accountPartnerships[field.name] || '',
      )
    }
    return {}
  },
)
